// ============================================================================
// src/webforms/webformsRoutes.ts — the report/form surfaces' route table.
// ============================================================================
// B3.1 finish, sixth and last domain. Same shape as the five before it, and
// the only one where a dedicated view is NESTED INSIDE another view's record
// space:
//
//   webformhub   owns /dailys and everything under it
//   tasksWebform owns /dailys/tasks exactly
//
// Both directions of the app already encode that precedence. The URL→view
// adapter in App resolves an exact PATH_TO_VIEW entry before its generic
// sub-path fallback (`!exactPathView && pathname.startsWith('/dailys/')`), and
// react-router ranks a static segment above a splat, so '/dailys/tasks' beats
// '/dailys/*' natively. `routedLocationFor` carries the same rule on the
// ownership side -- see claimedExactlyByAnotherRow in
// src/app/navigation/viewRoutes.js.
//
// These surfaces are LOGIN-REQUIRED but not program-scoped: every
// authenticated user including Light reaches them. The LoginScreen gate stays
// in App, above the point where this table is consulted. Two guards pin that
// ordering in two halves each -- rls_write_boundary_plan_static and
// prod_stability_audit_locks -- and the anon-write boundary rests on them.
//
//   /dailys/<form>     WebformHub owns its own sub-routing
//   /equipment/<slug>  FuelingHub owns its per-piece detail
// ============================================================================

// The signed-in identity reaches every surface in this table as a plain prop,
// so the presenters keep zero auth-session coupling. App injects direct form
// surfaces; FuelingAuthenticatedBridge derives the same narrow name-only
// value for /equipment/* and /fuel-supply from AuthContext.
//
// Only `name` is declared, because it is the only member any of the seven
// surfaces reads, and each of them reads it as `sessionSubmitter?.name || ''`.
// That optional chain is also why the prop itself is optional at every
// component: the forms are written to render without an identity, and naming
// members none of them touches would claim a contract nothing here checks.
export type SessionSubmitter = {name?: string | null};

export const WEBFORMS_ROUTES = [
  {view: 'webform', paths: ['/webform-pigs']},
  {view: 'addfeed', paths: ['/addfeed']},
  {view: 'weighins', paths: ['/weighins']},
  {view: 'tasksWebform', paths: ['/dailys/tasks']},
  {view: 'webformhub', paths: ['/dailys/*']},
  {view: 'fuelingHub', paths: ['/equipment/*']},
  {view: 'fuelSupply', paths: ['/fuel-supply']},
];
